// extracted by mini-css-extract-plugin
export default {"header":"AppHeader_header__4+d+2","content":"AppHeader_content__sCiJV","spin":"AppHeader_spin__ZPCHZ"};